import Swiper, {Autoplay} from 'swiper';

export class CertificationsHomeComponent {
  config = {
    slidesPerView: 'auto',
    spaceBetween: 7,
    autoplay: {
      delay: 3500
    }
  };

  container = null;

  swiper = null;

  constructor() {
    const carousels = document.querySelectorAll('.certifications-carousel-main.certifications-carousel:not(.elementor-hidden-mobile) .elementor-column');
    if (carousels.length) {
      this.container = carousels[carousels.length - 1];
    }

    if (!this.container) {
      return;
    }

    this.initialize();

    this.addEventListeners();
  }

  initialize() {
    if (window.outerWidth <= 768) {
      this.createCarousel();
    }
  }

  addEventListeners() {
    window.addEventListener('resize', (e) => this.windowResizeHandler(e));
  }

  windowResizeHandler() {
    window.outerWidth > 768
      ? this.destroyCarousel()
      : this.createCarousel();
  }

  createCarousel() {
    if (this.swiper) {
      return;
    }

    const container = this.container;
    if (!container) {
      return;
    }

    container.classList.add('swiper-container');

    const wrapper = container.querySelector('.elementor-widget-wrap');
    if (!wrapper) {
      return;
    }

    wrapper.classList.add('swiper-wrapper');

    const items = wrapper.getElementsByClassName('certifications-carousel__item');
    if (items.length) {
      Array.from(items).forEach((item) => {
        item.classList.add('swiper-slide');
      });
    }

    this.swiper = new Swiper(container, this.config);
  }

  destroyCarousel() {
    const swiper = this.swiper;
    if (!swiper) {
      return;
    }

    const container = this.container;
    if (!container) {
      return;
    }

    container.classList.remove('swiper-container');

    const wrapper = container.querySelector('.swiper-wrapper');
    if (!wrapper) {
      return;
    }

    wrapper.classList.remove('swiper-wrapper');

    const items = wrapper.getElementsByClassName('certifications-carousel__item');
    if (items.length) {
      Array.from(items).forEach((item) => {
        item.classList.remove('swiper-slide');
      });
    }

    swiper.destroy();
    this.swiper = null;
  }
}